/* eslint-disable react/display-name */
import React, { useState } from 'react'
import styled from 'styled-components'
import { FileDoneOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { GrnListData } from 'Store/grn/types'
import { selectGrnListEvent, selectGrnActionEvent, selectGrnImproveList } from 'Store/grn/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { formatDateWithoutTime, getGrnStatus, numberWithComma } from 'helpers/format'
import { ExpireDate, StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { ActionButton } from 'Components/button'
import GrnDetail from '../detail'
import { Pagination } from 'Components/Pagination'
import { SupplierData } from 'Store/supplier/types'
import { GrnStatus } from 'helpers/constanst'
import theme from 'Components/common/Theme'

type Pagination = {
  Page: number
  RowPerPage: number
}

type Props = {
  onGetList: () => void
  setPagination: (pagination: Pagination) => void
  pagination: Pagination
  onPaymentSuccess: () => void
  isPatial?: boolean
  isSuccess?: boolean
  onSort?: (order_by: string, sort: string) => void
} & ReduxProps

const GrnTable: React.FunctionComponent<Props> = props => {
  const {
    listEvent,
    list,
    setPagination,
    pagination,
    onGetList,
    onPaymentSuccess,
    isPatial = false,
    isSuccess = false,
    onSort = () => {},
  } = props
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const meta = list.meta
  const datas = list.data

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const onClickViewDetail = (id: number) => {
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const onSuccess = () => {
    //onCloseDetailDrawer()
    onGetList()
  }

  const renderStatus = (status: string) => {
    const statusResult = getGrnStatus(status)
    return (
      <div className="ttr-status-data">
        <StatusTag text={statusResult.text} color={statusResult.color} />
      </div>
    )
  }

  const renderActionButton = (text: string, record: GrnListData) => {
    return (
      <Space size="middle">
        <ActionButton
          text=""
          icon={<FileDoneOutlined />}
          label="รายละเอียด"
          action="edit"
          onClick={() => onClickViewDetail(record.grn_id)}
        />
      </Space>
    )
  }

  const renderPaymentDate = (value: string, record: GrnListData) => {
    const isPending = record.status === GrnStatus.PENDING
    return isPending ? (
      <ExpireDate date={record.payment_date || ''} />
    ) : (
      formatDateWithoutTime(record.payment_date || '')
    )
  }

  const renderRemainAmount = (value: number) => {
    if (!isPatial) return ''
    return <TextPrimary>{numberWithComma(value, true)}</TextPrimary>
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '40px',
    },
    {
      title: 'เลขที่ใบจ่ายหนี้',
      dataIndex: 'grn_no',
      key: 'grn_no',
      width: '160px',
      render: (val: string, record: GrnListData) => (
        <LinkNo onClick={() => onClickViewDetail(record.grn_id)} className="ttr-no">
          {val}
        </LinkNo>
      ),
      sorter: true,
    },
    {
      title: 'เลขที่ใบสั่งซื้อ',
      dataIndex: 'purchasing_no',
      key: 'purchasing_no',
      width: '160px',
      sorter: true,
    },
    {
      title: 'ชื่อ Supplier',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      width: '120px',
      sorter: true,
    },
    {
      title: <TextRight>จำนวน</TextRight>,
      dataIndex: 'total_recieved_amount',
      key: 'total_recieved_amount',
      width: '80px',
      render: (value: any) => {
        return <TextRight>{numberWithComma(value)}</TextRight>
      },
      sorter: true,
    },
    {
      title: <TextRight>ราคารวม</TextRight>,
      dataIndex: 'total_original_recieved_price',
      key: 'total_original_recieved_price',
      width: '100px',
      render: (value: any, record: GrnListData) => {
        return (
          <TextRight>{numberWithComma(value - (record?.total_credit_note_discount || 0), true)}</TextRight>
        )
      },
      sorter: true,
    },
    {
      title: isPatial ? <TextRight>ค้างชำระ</TextRight> : '',
      dataIndex: 'total_recieve_price',
      key: 'total_recieve_price',
      width: isPatial ? '100px' : '0px',
      render: renderRemainAmount,
      sorter: true,
    },
    // {
    //   title: 'วันที่สั่งซื้อ',
    //   dataIndex: 'purchasing',
    //   key: 'purchasing_date',
    //   render: (val: PurchaseData) => {
    //     return formatDateWithoutTime(val?.purchasing_date || '')
    //   },
    // },
    {
      title: 'วันที่รับเข้าคลัง',
      dataIndex: 'received_date',
      key: 'received_date',
      width: '100px',
      render: (value: any) => {
        return formatDateWithoutTime(value)
      },
      sorter: true,
    },
    {
      title: !isSuccess ? 'กำหนดชำระ' : '',
      dataIndex: 'payment_date',
      key: 'payment_date',
      width: !isSuccess ? '100px' : '0px',
      render: (value: any, record: any) => {
        return <div className="ttr-payment-date">{!isSuccess ? renderPaymentDate(value, record) : ''}</div>
      },
      sorter: true,
    },
    // {
    //   title: 'กำหนดชำระ',
    //   dataIndex: 'payment_date',
    //   key: 'payment_date',
    //   render: renderPaymentDate,
    // },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      render: renderStatus,
      width: '60px',
      sorter: true,
    },
    // {
    //   title: '',
    //   key: 'action',
    //   render: renderActionButton,
    // },
  ]

  const DetailDrawer = (
    <GrnDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={onSuccess}
      onPaymentSuccess={onPaymentSuccess}
    />
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
      className="ttr-pagination"
    />
  )

  return (
    <>
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={listEvent.IsLoading}
        paginationContent={PaginationContent}
        onSort={onSort}
      />
      {DetailDrawer}
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectGrnImproveList(state),
    listEvent: selectGrnListEvent(state),
    event: selectGrnActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const TextRight = styled.div`
  text-align: right;
  margin-right: 20px;
`

const TextPrimary = styled(TextRight)`
  color: ${theme.colors.primary};
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

export default connect(mapStateToProps)(GrnTable)
